import React, { useEffect, useState } from 'react';
import { useCommonSelector } from '@wajeez-web/stores/common';
import { Transition } from '@headlessui/react';
import { useQuery } from '@wajeez-web/components/helpers';
import { useLocation } from 'react-router-dom';
import { updateUrlQuery } from '@wajeez-web/core/utils';
import { useParams } from 'react-router-dom';
import { Tabs, TabsWithHeaders } from '@wajeez-web/components/ui';

export interface WajeezTabsContainerProps {
  title: string;
  desc?: string;
  tabsType?: 'fullWidth' | 'normal';

  headerComponent?: React.ReactNode;
  tabs: {
    text: string;
    disabled: boolean;
    content: () => JSX.Element;
  }[];
}

const WajeezTabsContainer = ({
  title,
  desc,
  tabsType = 'normal',
  tabs,
  headerComponent,
}: WajeezTabsContainerProps) => {
  const { tab } = useParams<{ tab: string }>();
  const [selectedTab, setSelectedTab] = useState(tab ? Number(tab) : 0);
  const { innerPageSideBarCollapsed } = useCommonSelector(
    (state) => state.common.settings
  );

  const location = useLocation();

  useEffect(() => {
    setSelectedTab(tab ? Number(tab) : 0);
  }, [location.pathname, tab]);

  const selectTab = (selected: number) => {
    setSelectedTab(selected);
  };

  return (
    <div
      className={`${
        tabsType === 'fullWidth' ? 'grid grid-cols-4' : 'flex'
      } overflow-hidden bg-white h-inner-screen w-full`}
    >
      <Transition
        className={'h-full'}
        show={!innerPageSideBarCollapsed}
        // enter="transition-all ease duration-1000 transform"
        // enterFrom="w-0"
        // enterTo="w-full"
        // leave="transition-all ease   transform"
        // leaveFrom="w-full"
        // leaveTo="w-0"
      >
        <div
          className={`h-full overflow-hidden ${
            tabsType === 'fullWidth'
              ? ''
              : 'lg:w-52 md:w-36 bg-white border-e shadow-lg border-warmGray-200'
          }`}
        >
          {tabsType === 'fullWidth' ? (
            <div className="md:col-span-1 h-full flex flex-grow overflow-hidden">
              <TabsWithHeaders
                header={title}
                tabs={tabs}
                selectedTab={selectedTab}
                setSelectedTab={selectTab}
              />
            </div>
          ) : (
            <div className="h-full py-4 divide-y space-y-4">
              <div className="px-2 text-center">
                <h3 className="text-lg font-bold text-gray-900">
                  {title.split('"')[0]}
                </h3>
                {title.split('"')[1] && (
                  <h3 className="text-base font-semibold text-gray-900">
                    " {title.split('"')[1]} "
                  </h3>
                )}
                <p className="mt-1 text-sm text-gray-600">{desc}</p>
              </div>
              <Tabs
                tabs={tabs}
                selectedTab={selectedTab}
                setSelectedTab={selectTab}
              />
            </div>
          )}
        </div>
      </Transition>
      <div
        className={`h-full md:mt-0 w-full ${
          innerPageSideBarCollapsed ? 'col-span-4' : 'col-span-3'
        } flex-grow overflow-y-auto focus:outline-none space-y-4`}
      >
        {headerComponent}
        <div
          className={`${
            tabsType === 'fullWidth' ? 'grid grid-cols-3' : 'w-full'
          } h-full px-4 py-4`}
        >
          <div
            className={`${
              tabsType === 'fullWidth' ? 'col-span-3' : 'flex-grow'
            } sm:grid-cols-3 pb-4 xl:m-6 lg:m-4`}
          >
            {tabs[selectedTab]?.content()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WajeezTabsContainer;
